import type { DriveItem } from '../types';

// Local-first cache for the Recent view — lets it render instantly from the
// last known list (localStorage) instead of showing a spinner every visit.
// The server fetch (fetchRecentItems) still runs in the background and
// reconciles/replaces this the moment it resolves.
const CACHE_KEY = 'skdrive.recentItemsCache';
const MAX_ITEMS = 50;

export function loadRecentCache(): DriveItem[] {
  if (typeof localStorage === 'undefined') return [];
  try {
    return JSON.parse(localStorage.getItem(CACHE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function saveRecentCache(items: DriveItem[]): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
  } catch {}
}

/**
 * Bump an item to the front of the local cache the instant it's opened, so
 * "Recent" reflects it immediately in this tab — before the next server
 * fetch (which re-sorts by the backend's last_used) round-trips.
 */
export function markOpenedLocally(item: DriveItem): void {
  const cached = loadRecentCache();
  saveRecentCache([item, ...cached.filter((i) => i.id !== item.id)]);
}
